export const saveIcon = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6849 4L6.35152 11.3333L3.01819 8"
      stroke="black"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const pendingicon=<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M9.62171 19.2434C14.9356 19.2434 19.2434 14.9356 19.2434 9.62171C19.2434 4.30779 14.9356 0 9.62171 0C4.30779 0 0 4.30779 0 9.62171C0 14.9356 4.30779 19.2434 9.62171 19.2434Z" fill="#E17954"/>
</svg>
export const crossIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 4L4 12"
      stroke="#0A0A0A"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 4L12 12"
      stroke="#0A0A0A"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const todayIcon = (
  <svg
    width="22"
    height="23"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.1667 5.16663H5.83333C4.54467 5.16663 3.5 6.21129 3.5 7.49996V23.8333C3.5 25.122 4.54467 26.1666 5.83333 26.1666H22.1667C23.4553 26.1666 24.5 25.122 24.5 23.8333V7.49996C24.5 6.21129 23.4553 5.16663 22.1667 5.16663Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.6667 2.83337V7.50004"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33334 2.83337V7.50004"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 12.1666H24.5"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const penIcon = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 3C14.3789 2.7492 14.6414 2.54505 14.9375 2.40057C15.2336 2.25609 15.5568 2.17445 15.8864 2.16085C16.216 2.14725 16.5449 2.20198 16.852 2.32157C17.1591 2.44116 17.4378 2.62298 17.6703 2.85544C17.9027 3.08789 18.0839 3.36589 18.2021 3.6717C18.3204 3.97752 18.3732 4.30445 18.3572 4.63165C18.3412 4.95885 18.2567 5.27916 18.1091 5.57214C17.9615 5.86512 17.7541 6.12436 17.5 6.33333L6.25002 17.5833L1.66669 18.8333L2.91669 14.25L14.1667 3Z"
      stroke="#99A1AF"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 4.66663L15.8333 7.99996"
      stroke="#99A1AF"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const pinfilled=<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <rect width="14" height="14" fill="white"/>
  <path d="M7 9.9165V12.8332" stroke="#D1D5DB" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2.91699 9.9165H11.0837V8.88984C11.0835 8.67279 11.0229 8.46007 10.9085 8.27561C10.7941 8.09115 10.6305 7.94226 10.4362 7.84567L9.39783 7.32067C9.20345 7.22408 9.03988 7.07519 8.92549 6.89073C8.8111 6.70627 8.75044 6.49355 8.75033 6.2765V3.49984H9.33366C9.64308 3.49984 9.93982 3.37692 10.1586 3.15813C10.3774 2.93934 10.5003 2.64259 10.5003 2.33317C10.5003 2.02375 10.3774 1.72701 10.1586 1.50821C9.93982 1.28942 9.64308 1.1665 9.33366 1.1665H4.66699C4.35757 1.1665 4.06083 1.28942 3.84203 1.50821C3.62324 1.72701 3.50033 2.02375 3.50033 2.33317C3.50033 2.64259 3.62324 2.93934 3.84203 3.15813C4.06083 3.37692 4.35757 3.49984 4.66699 3.49984H5.25033V6.2765C5.25021 6.49355 5.18955 6.70627 5.07516 6.89073C4.96078 7.07519 4.7972 7.22408 4.60283 7.32067L3.56449 7.84567C3.37012 7.94226 3.20654 8.09115 3.09216 8.27561C2.97777 8.46007 2.91711 8.67279 2.91699 8.88984V9.9165Z" fill="#D9D9D9" stroke="#D1D5DB" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
export const pendingIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_8747_6008"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
      /* removed style="mask-type:luminance" */
    >
      <path d="M0 0H19.5V19.5H0V0Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.97 4.49988H7.53001C7.30501 4.49988 7.19251 4.67013 7.20901 4.81488C7.29451 5.55963 7.45501 6.41463 7.72351 6.96138C8.08126 7.69113 8.94451 8.51088 9.59626 9.05313C9.63873 9.09057 9.6934 9.11122 9.75001 9.11122C9.80663 9.11122 9.86129 9.09057 9.90376 9.05313C10.5563 8.51088 11.4188 7.69113 11.7765 6.96063C12.045 6.41463 12.2055 5.55963 12.2918 4.81488C12.3083 4.67013 12.195 4.49988 11.9708 4.49988M7.53076 3.74988C6.89776 3.74988 6.39151 4.27188 6.46426 4.90038C6.55126 5.65413 6.72151 6.62088 7.05076 7.29138C7.48651 8.17938 8.46676 9.08838 9.11776 9.62988C9.48826 9.93738 10.0133 9.93738 10.3838 9.62988C11.0348 9.08838 12.015 8.17938 12.4508 7.29138C12.78 6.62088 12.9503 5.65413 13.0373 4.90038C13.1093 4.27188 12.603 3.74988 11.97 3.74988H7.53076Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53 14.9999H11.97C12.195 14.9999 12.3075 14.8296 12.291 14.6849C12.2055 13.9401 12.045 13.0851 11.7765 12.5391C11.4187 11.8086 10.5555 10.9881 9.90375 10.4466C9.86128 10.4092 9.80661 10.3885 9.75 10.3885C9.69339 10.3885 9.63872 10.4092 9.59625 10.4466C8.94375 10.9889 8.08125 11.8086 7.7235 12.5391C7.455 13.0851 7.2945 13.9401 7.20825 14.6849C7.19175 14.8296 7.305 14.9999 7.52925 14.9999M11.9692 15.7499C12.6022 15.7499 13.1085 15.2279 13.0358 14.5994C12.9488 13.8449 12.7785 12.8789 12.4493 12.2084C12.0135 11.3204 11.0333 10.4114 10.3823 9.86988C10.2051 9.72063 9.98089 9.63879 9.74925 9.63879C9.51761 9.63879 9.29341 9.72063 9.11625 9.86988C8.46525 10.4114 7.485 11.3204 7.04925 12.2084C6.72 12.8789 6.54975 13.8456 6.46275 14.5994C6.39 15.2279 6.89625 15.7499 7.5285 15.7499H11.9692ZM5.25 4.12488C5.25 4.02542 5.28951 3.93004 5.35984 3.85971C5.43016 3.78939 5.52554 3.74988 5.625 3.74988H13.875C13.9745 3.74988 14.0698 3.78939 14.1402 3.85971C14.2105 3.93004 14.25 4.02542 14.25 4.12488C14.25 4.22433 14.2105 4.31972 14.1402 4.39004C14.0698 4.46037 13.9745 4.49988 13.875 4.49988H5.625C5.52554 4.49988 5.43016 4.46037 5.35984 4.39004C5.28951 4.31972 5.25 4.22433 5.25 4.12488Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 15.3749C5.25 15.2754 5.28951 15.18 5.35984 15.1097C5.43016 15.0394 5.52554 14.9999 5.625 14.9999H13.875C13.9745 14.9999 14.0698 15.0394 14.1402 15.1097C14.2105 15.18 14.25 15.2754 14.25 15.3749C14.25 15.4743 14.2105 15.5697 14.1402 15.64C14.0698 15.7104 13.9745 15.7499 13.875 15.7499H5.625C5.52554 15.7499 5.43016 15.7104 5.35984 15.64C5.28951 15.5697 5.25 15.4743 5.25 15.3749Z"
        fill="black"
      />
    </mask>

    <g mask="url(#mask0_8747_6008)">
      <path
        d="M9.62171 19.2434C14.9356 19.2434 19.2434 14.9356 19.2434 9.62171C19.2434 4.30779 14.9356 0 9.62171 0C4.30779 0 0 4.30779 0 9.62171C0 14.9356 4.30779 19.2434 9.62171 19.2434Z"
        fill="#E17954"
      />
    </g>
  </svg>
);

export const expandIcon = (
 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M1.29167 14.2083H5.81251C5.99592 14.2083 6.1492 14.2703 6.27234 14.3943C6.39548 14.5183 6.45748 14.672 6.45834 14.8555C6.4592 15.0389 6.3972 15.1922 6.27234 15.3153C6.14748 15.4384 5.9942 15.5 5.81251 15.5H1.04367C0.748311 15.5 0.500311 15.4001 0.299672 15.2003C0.0990331 15.0006 -0.000855591 14.7526 5.51995e-06 14.4563V9.6875C5.51995e-06 9.50408 0.0620056 9.35081 0.186006 9.22767C0.310006 9.10453 0.463714 9.04253 0.64713 9.04167C0.830547 9.0408 0.983825 9.10281 1.10696 9.22767C1.2301 9.35253 1.29167 9.50581 1.29167 9.6875V14.2083ZM14.2083 1.29167H9.6875C9.50409 1.29167 9.35081 1.22967 9.22767 1.10567C9.10453 0.981667 9.04253 0.827958 9.04167 0.644542C9.04081 0.461125 9.10281 0.307847 9.22767 0.184708C9.35253 0.0615696 9.50581 0 9.6875 0H14.4563C14.7526 0 15.0006 0.0998887 15.2003 0.299666C15.4001 0.499444 15.5 0.747445 15.5 1.04367V5.8125C15.5 5.99592 15.438 6.14919 15.314 6.27233C15.19 6.39547 15.0363 6.45747 14.8529 6.45833C14.6695 6.45919 14.5162 6.39719 14.393 6.27233C14.2699 6.14747 14.2083 5.99419 14.2083 5.8125V1.29167Z" fill="#99A1AF"/>
</svg>
);

export const collapseIcon=<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M4 10H1C0.71667 10 0.479337 9.904 0.288004 9.712C0.0966702 9.52 0.000670115 9.28267 3.44827e-06 9C-0.000663218 8.71734 0.0953369 8.48 0.288004 8.288C0.48067 8.096 0.718003 8 1 8H5C5.28334 8 5.521 8.096 5.713 8.288C5.905 8.48 6.00067 8.71734 6 9V13C6 13.2833 5.904 13.521 5.712 13.713C5.52 13.905 5.28267 14.0007 5 14C4.71734 13.9993 4.48 13.9033 4.288 13.712C4.096 13.5207 4 13.2833 4 13V10ZM10 4H13C13.2833 4 13.521 4.096 13.713 4.288C13.905 4.48 14.0007 4.71734 14 5C13.9993 5.28267 13.9033 5.52034 13.712 5.713C13.5207 5.90567 13.2833 6.00134 13 6H9C8.71667 6 8.47934 5.904 8.288 5.712C8.09667 5.52 8.00067 5.28267 8 5V1C8 0.71667 8.096 0.479337 8.288 0.288004C8.48 0.0966702 8.71734 0.000670115 9 3.44827e-06C9.28267 -0.000663218 9.52034 0.0953369 9.713 0.288004C9.90567 0.48067 10.0013 0.718003 10 1V4Z" fill="#99A1AF"/>
</svg>
export const scheduledIcon = (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 24.75C19.7132 24.75 24.75 19.7132 24.75 13.5C24.75 7.2868 19.7132 2.25 13.5 2.25C7.2868 2.25 2.25 7.2868 2.25 13.5C2.25 19.7132 7.2868 24.75 13.5 24.75Z"
      stroke="black"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.5 6.75V13.5L18 15.75"
      stroke="black"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RXIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8747_6098)">
      <g filter="url(#filter0_d_8747_6098)">
        <mask id="path-3-inside-1_8747_6098" fill="white">
          <path d="M10.2262 9.51255V6.66663H9.28705V9.51255H6V10.3257H9.28705V13.1716H10.2262V10.3257H13.5133V9.51255H10.2262Z" />
        </mask>
        <path
          d="M10.2262 9.51255V6.66663H9.28705V9.51255H6V10.3257H9.28705V13.1716H10.2262V10.3257H13.5133V9.51255H10.2262Z"
          fill="#99A1AF"
        />
        <path
          d="M10.2262 9.51255H8.2262V11.5126H10.2262V9.51255ZM10.2262 6.66663H12.2262V4.66663H10.2262V6.66663ZM9.28705 6.66663V4.66663H7.28705V6.66663H9.28705ZM9.28705 9.51255V11.5126H11.287V9.51255H9.28705ZM6 9.51255V7.51255H4V9.51255H6ZM6 10.3257H4V12.3257H6V10.3257ZM9.28705 10.3257H11.287V8.32568H9.28705V10.3257ZM9.28705 13.1716H7.28705V15.1716H9.28705V13.1716ZM10.2262 13.1716V15.1716H12.2262V13.1716H10.2262ZM10.2262 10.3257V8.32568H8.2262V10.3257H10.2262ZM13.5133 10.3257V12.3257H15.5133V10.3257H13.5133ZM13.5133 9.51255H15.5133V7.51255H13.5133V9.51255ZM10.2262 9.51255H12.2262V6.66663H10.2262H8.2262V9.51255H10.2262ZM10.2262 6.66663V4.66663H9.28705V6.66663V8.66663H10.2262V6.66663ZM9.28705 6.66663H7.28705V9.51255H9.28705H11.287V6.66663H9.28705ZM9.28705 9.51255V7.51255H6V9.51255V11.5126H9.28705V9.51255ZM6 9.51255H4V10.3257H6H8V9.51255H6ZM6 10.3257V12.3257H9.28705V10.3257V8.32568H6V10.3257ZM9.28705 10.3257H7.28705V13.1716H9.28705H11.287V10.3257H9.28705ZM9.28705 13.1716V15.1716H10.2262V13.1716V11.1716H9.28705V13.1716ZM10.2262 13.1716H12.2262V10.3257H10.2262H8.2262V13.1716H10.2262ZM10.2262 10.3257V12.3257H13.5133V10.3257V8.32568H10.2262V10.3257ZM13.5133 10.3257H15.5133V9.51255H13.5133H11.5133V10.3257H13.5133ZM13.5133 9.51255V7.51255H10.2262V9.51255V11.5126H13.5133V9.51255Z"
          fill="#99A1AF"
          mask="url(#path-3-inside-1_8747_6098)"
        />
      </g>
    </g>
    <rect
      x="0.75"
      y="0.75"
      width="18.5"
      height="18.5"
      rx="2.25"
      stroke="#99A1AF"
      stroke-width="1.5"
    />
    <defs>
      <filter
        id="filter0_d_8747_6098"
        x="-2"
        y="-1.33337"
        width="23.5132"
        height="22.505"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8747_6098"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8747_6098"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_8747_6098">
        <rect width="20" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const prescriptionIcon = (
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5392 27.0997L23.3894 25.1957L20.3877 22.1476L18.5141 24.0264C18.0828 24.4652 17.8672 24.9776 17.8672 25.5637C17.8672 26.1498 18.0828 26.6618 18.5141 27.0997C18.9453 27.5375 19.4495 27.7565 20.0266 27.7565C20.6038 27.7565 21.108 27.5375 21.5392 27.0997ZM24.2415 24.3316L26.1152 22.4528C26.5464 22.0149 26.7583 21.5029 26.7509 20.9168C26.7435 20.3307 26.5237 19.8183 26.0917 19.3796C25.6605 18.9584 25.1604 18.7437 24.5915 18.7353C24.0226 18.7269 23.5221 18.9417 23.0901 19.3796L21.2399 21.2835L24.2415 24.3316ZM22.3987 27.9951C21.7309 28.6733 20.9365 29.0082 20.0155 28.9998C19.0937 28.9915 18.2993 28.6566 17.6323 27.9951C16.9801 27.3169 16.6503 26.5102 16.6428 25.575C16.6354 24.6397 16.9652 23.833 17.6323 23.1548L22.2318 18.4829C22.8831 17.8214 23.6775 17.4907 24.615 17.4907C25.5516 17.4907 26.346 17.8214 26.9982 18.4829C27.6661 19.161 28 19.9682 28 20.9043C28 21.8403 27.6661 22.647 26.9982 23.3244L22.3987 27.9951ZM6.9986 25.6064C6.44453 25.6064 5.97292 25.4088 5.58375 25.0136C5.19458 24.6184 5 24.1399 5 23.5781V7.54011C5 6.97914 5.19458 6.50064 5.58375 6.10461C5.97292 5.70942 6.44453 5.51182 6.9986 5.51182H12.8114C12.6984 4.87047 12.8493 4.29149 13.264 3.7749C13.6779 3.2583 14.2213 3 14.8941 3C15.5825 3 16.1341 3.2583 16.5489 3.7749C16.9636 4.29149 17.1066 4.87047 16.978 5.51182H22.7908C23.3432 5.51182 23.8144 5.70942 24.2044 6.10461C24.5936 6.4998 24.7881 6.97872 24.7881 7.54137V14.0495C24.582 14.0252 24.3759 14.021 24.1698 14.0369C23.9636 14.0528 23.7575 14.0763 23.5514 14.1073V7.54137C23.5514 7.31531 23.4801 7.12985 23.3374 6.985C23.1948 6.84015 23.0126 6.76773 22.7908 6.76773H6.99736C6.77557 6.76773 6.59336 6.84015 6.45072 6.985C6.30808 7.12985 6.23676 7.31531 6.23676 7.54137V23.5781C6.23676 23.8033 6.30808 23.9883 6.45072 24.1332C6.59336 24.278 6.77599 24.3505 6.9986 24.3505H13.3456C13.2995 24.5598 13.2686 24.7691 13.2529 24.9784C13.2372 25.1877 13.2413 25.3971 13.2653 25.6064H6.9986ZM14.8941 6.06693C15.162 6.06693 15.3838 5.97818 15.5594 5.80068C15.7351 5.62318 15.8225 5.39795 15.8216 5.125C15.8208 4.85205 15.733 4.62724 15.5582 4.45058C15.3834 4.27391 15.162 4.18474 14.8941 4.18307C14.6261 4.18139 14.4047 4.27056 14.2299 4.45058C14.0551 4.63059 13.9673 4.8554 13.9665 5.125C13.9657 5.3946 14.0535 5.61983 14.2299 5.80068C14.4064 5.98153 14.6278 6.07028 14.8941 6.06693ZM9.32866 11.4535V10.1976H20.4595V11.4535H9.32866ZM9.32866 16.1871V14.9311H20.4595V15.4436C20.3424 15.5323 20.2344 15.6202 20.1355 15.7073C20.0365 15.7944 19.9281 15.8978 19.8102 16.0175L19.6445 16.1871H9.32866ZM9.32866 20.9218V19.6659H16.2186L15.8686 20.0201C15.7202 20.1708 15.5747 20.3211 15.4321 20.471C15.2902 20.6192 15.1521 20.769 15.0177 20.9206L9.32866 20.9218Z"
      fill="black"
    />
  </svg>
);

export const notesIcon = (
  <svg
    width="30"
    height="32"
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8747_6139)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M29.9487 7.77184C29.7978 7.20402 29.5138 6.68032 29.1202 6.24412C28.7266 5.80792 28.2347 5.47177 27.6853 5.26351C26.648 4.81071 25.4792 4.76079 24.407 5.12351C23.9679 5.30588 23.5705 5.57581 23.2392 5.91684C22.7516 6.397 22.3562 6.96245 22.0725 7.58517C21.912 7.89449 21.7943 8.22417 21.7225 8.56517C21.6965 8.66259 21.7085 8.76627 21.7562 8.85512C21.8039 8.94397 21.8836 9.01133 21.9792 9.04351C22.0228 9.0602 22.0693 9.06799 22.116 9.06643C22.1626 9.06487 22.2085 9.05398 22.2509 9.03441C22.2933 9.01484 22.3314 8.98698 22.3629 8.95248C22.3943 8.91798 22.4186 8.87752 22.4342 8.83351L22.7958 7.98184C23.0318 7.55414 23.3263 7.16146 23.6708 6.81517C23.9844 6.52189 24.3649 6.30963 24.7792 6.19684C25.5686 6.02564 26.393 6.13282 27.1125 6.50017C27.486 6.61467 27.8284 6.8129 28.1137 7.07978C28.399 7.34666 28.6196 7.67513 28.7587 8.04017C28.9337 8.63984 28.9663 9.27101 28.852 9.8835C28.7313 10.5035 28.5272 11.1044 28.2453 11.6697L28.0937 11.588C26.857 10.958 23.917 9.47634 23.0175 8.97467C22.9229 8.92463 22.8125 8.9137 22.7099 8.94425C22.6074 8.97479 22.5209 9.04437 22.4692 9.138C22.4191 9.23258 22.4082 9.34302 22.4387 9.44556C22.4693 9.54811 22.5389 9.63456 22.6325 9.68634L27.8125 12.5097C27.7075 12.743 27.5325 13.093 27.3108 13.5247C25.8875 16.3492 22.4808 22.6982 21.2675 24.8098C20.7757 24.3205 20.2451 23.8718 19.6808 23.4682C19.4008 23.2815 19.0975 23.0948 18.8058 22.9315C18.5004 22.7701 18.1843 22.6298 17.8597 22.5115C17.262 22.2907 16.6448 22.1266 16.0163 22.0215C16.0513 21.8768 16.098 21.7368 16.1563 21.6015C17.2297 19.1153 20.0297 13.6308 21.313 11.098C21.6047 10.538 21.8147 10.1297 21.908 9.93134C22.1413 9.48801 21.4297 9.37134 21.418 9.38301C21.1241 9.81188 20.8665 10.2646 20.648 10.7363C19.2363 13.2913 16.203 18.6603 15.048 21.1103C14.7797 21.577 14.6047 22.0927 14.5347 22.627C14.6163 23.117 15.1297 26.5832 15.468 27.9727C15.5287 28.3437 15.7037 28.6855 15.9697 28.9527C16.1808 29.074 16.4247 29.1312 16.6697 29.116C17.2081 29.0492 17.7321 28.8956 18.2213 28.661C19.5209 28.059 20.7272 27.2732 21.803 26.3277C22.0947 26.001 25.6075 19.2437 27.5337 15.2758C28.1053 14.1092 28.537 13.1875 28.7003 12.7442C29.1258 11.8629 29.4874 10.9564 29.7853 10.0247C29.9954 9.29357 30.051 8.5256 29.9487 7.77184ZM16.9613 27.7393H16.7863C16.7863 27.7393 15.993 23.8882 15.8063 22.8498C16.3547 23.1182 16.973 23.4798 17.568 23.8298C17.9297 24.0398 18.3147 24.2265 18.7347 24.4248C19.1547 24.6232 19.5163 24.7865 19.9013 24.9848L20.8113 25.5332C20.151 26.0803 19.4347 26.5575 18.6763 26.9565C18.1338 27.2773 17.5587 27.541 16.9613 27.7393Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.0163 30.2711C15.3016 30.1181 14.5965 29.9233 13.9047 29.6877C13.4695 29.5408 13.0508 29.3493 12.6552 29.1161C12.3258 28.9273 12.0831 28.6176 11.9785 28.2527C11.9467 27.7373 12.0222 27.2208 12.2002 26.7361C12.438 26.0199 12.438 25.2461 12.2002 24.5299C12.0025 24.1211 11.6796 23.786 11.2785 23.5732C10.7866 23.2982 10.2417 23.1312 9.68015 23.0832C8.67417 23.0659 7.66907 23.1519 6.68065 23.3399C5.21065 23.6386 3.76049 24.0282 2.33949 24.5066C2.24982 24.5114 2.16515 24.5494 2.10183 24.613C2.03851 24.6767 2.00106 24.7616 1.9967 24.8513C1.99235 24.941 2.02141 25.0291 2.07826 25.0986C2.13511 25.1681 2.21571 25.214 2.30449 25.2276C2.35115 25.233 2.39782 25.2299 2.44449 25.2182C3.61115 24.9732 4.77782 24.7282 6.04949 24.5649C7.20884 24.3966 8.38398 24.3652 9.55065 24.4716C9.83998 24.5031 10.12 24.5859 10.379 24.7166C10.589 24.8216 10.8107 24.9266 10.8807 25.1016C11.024 25.5572 11.024 26.0459 10.8807 26.5016C10.6835 27.1803 10.6515 27.8963 10.7873 28.5899C10.8848 28.9132 11.0482 29.2128 11.267 29.47C11.4858 29.7272 11.7555 29.9364 12.059 30.0844C12.549 30.3302 13.0588 30.5207 13.5885 30.6561C14.3352 30.8521 15.0896 31.0037 15.8518 31.1111C15.9568 31.1281 16.0644 31.1036 16.1515 31.0425C16.2387 30.9815 16.2986 30.8889 16.3185 30.7844C16.3342 30.7308 16.3387 30.6745 16.3318 30.619C16.3248 30.5635 16.3066 30.5101 16.2781 30.462C16.2497 30.4138 16.2117 30.3721 16.1665 30.3392C16.1212 30.3064 16.0697 30.2832 16.0152 30.2711"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_8747_6139">
        <rect width="28" height="28" fill="white" transform="translate(2 4)" />
      </clipPath>
    </defs>
  </svg>
);
